import { render, staticRenderFns } from "./ThemeProvider.vue?vue&type=template&id=8d9720e8&"
import script from "./ThemeProvider.vue?vue&type=script&lang=js&"
export * from "./ThemeProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports